import React from 'react';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import { Box, Button, Link, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EmailIcon from '@mui/icons-material/Email';
import GavelIcon from '@mui/icons-material/Gavel';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import MapIcon from '@mui/icons-material/Map';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';

const services = [
    {
      title: 'Election Schedule Calculator',
      subtitle:
        'A calculator developed by OCPF for determining due dates and reporting periods for candidates and committees who file with their local election officials, such as school committee and selectboard.',
      icon: (
        <CalendarMonthIcon fontSize="large" />
      ),
      link: "#election-calculator"
    },
    {
      title: 'Sample Filing Notice',
      subtitle:
        'A sample e-mail notification to local filers from local election officials, usually sent weeks and days before a filing deadline.',
      icon: (
        <EmailIcon fontSize="large" />
      ),
      link: "/PublicSearch/ViewDocument?id=2896"
    },
    {
      title: 'Referral of Municipal Non-filers',
      subtitle:
        'This memorandum is to clarify the process by which local election officials - city and town clerks and election commissioners - refer to OCPF those candidates who fail to file campaign finance reports with their office.',
      icon: (
        <GavelIcon fontSize="large" />
      ),
      link: "http://files.ocpf.us/pdf/legaldocs/M-23-01.pdf"
    },
    {
      title: 'E-Guide for Candidates Who File Locally',
      subtitle:
        'Chapter 55, Section 27, requires OCPF to make available a summary of the campaign finance law to candidates and political committees.',
      icon: (
        <LibraryBooksIcon fontSize="large" />
      ),
      link: "/PublicSearch/ViewDocument?id=3773"
    },
    {
      title: 'Massachusetts Town & City Map',
      subtitle:
        'Click a city or town on the map and see campaign finance activity for elected officials for that community.',
      icon: (
        <MapIcon fontSize="large" />
      ),
      link: "/Municipal/Map"
    },
    {
      title: 'Municipal Online Treasurer Training',
      subtitle:
        'A twenty minutes training that provides the information the local filers need to know to successfully navigate the campaign finance law and file reports.',
      icon: (
        <OndemandVideoIcon fontSize="large" />
      ),
      link: "/Municipal/TreasurerTrainings"
    },
  ];

const FeaturedServices = (): JSX.Element => {

    const theme = useTheme();

    return (
    <Box marginTop={3} marginBottom={4}>
        <Box marginBottom={4}>
        <Typography
          variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          fontWeight={700}
          data-aos={'fade-up'}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          Featured Resources
        </Typography>
      </Box>
      <Grid container spacing={4}>
        {services.map((item, i) => (
          <Grid key={i} size={{xs:12, md:6}}>
            <ListItem
              component="div"
              disableGutters
              sx={{
                alignItems: 'flex-start',
                padding: 0,
              }}
            >
              <ListItemAvatar>
                <Box color={theme.palette.primary.main}>{item.icon}</Box>
              </ListItemAvatar>
              <ListItemButton component={Link} href={item.link}>
                <ListItemText
                    primary={item.title}
                    secondary={item.subtitle}
                    primaryTypographyProps={{
                        variant: 'h6',
                        gutterBottom: true,
                        sx: { fontWeight: 700 },
                        }}
                    sx={{
                        margin: 0,
                        marginTop: -1
                    }}
                />
              </ListItemButton>
            </ListItem>
          </Grid>
        ))}
      </Grid>
      <Box marginTop={3} display={'flex'} justifyContent={'center'}>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              component={Link}
              data-aos={'fade-up'}
              href='#municipal-guides'
            >
              View All Municipal E-Guides
            </Button>
        </Box>
    </Box>
    )

}

export default FeaturedServices;